module.exports = "v6.8.28";


//////////////////
// WEBPACK FOOTER
// ./node_modules/val-loader/dist/cjs.js!./src/builderVersion.js
// module id = 227
// module chunks = 0 1